import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

export const inspectionTemplateTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    name: Type.String({ maxLength: 255 }),
    isActive: makeNullable(Type.Boolean()),
});

export type InspectionTemplate = Static<typeof inspectionTemplateTableSchema>;
